import { useAppSelector } from 'src/app/store';

export function useIsEditingTrip() {
  const selectedTrip = useAppSelector((state) => state.addATrip.selectedTrip);
  return !!selectedTrip?.id;
}
